import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';
import * as Unicons from "@iconscout/react-unicons";
import { MdDehaze } from "react-icons/md";


export default function Navbar(){
    window.addEventListener("scroll", windowScroll);
    function windowScroll() {
        const navbar = document.getElementById("navbar");
        if (
            document.body.scrollTop >= 50 ||
            document.documentElement.scrollTop >= 50
        ) {
            if (navbar !== null) {
                navbar?.classList.add("is-sticky");
            }
        } else {
            if (navbar !== null) {
                navbar?.classList.remove("is-sticky");
            }
        }

        const mybutton = document.getElementById("back-to-top");
        if (mybutton != null) {
            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                mybutton.classList.add("flex");
                mybutton.classList.remove("hidden");
            } else {
                mybutton.classList.add("hidden");
                mybutton.classList.remove("flex");
            }
        }
    }

    const [hide,setHide]=useState("hidden");
    function hiddenFunc(){

        if(hide==="hidden"){
            setHide("")
            const show=document.getElementById("menu-collapse")
            show.classList.remove("hidden");
        
        }
        else{
            setHide("hidden")
            const show=document.getElementById("menu-collapse")
            
            show.classList.add("hidden")
        }
    }


    console.log(hide)
    return(
        <nav className="navbar" id="navbar">
        <div className="container flex flex-wrap items-center justify-between">
            <Link to= "/" className="navbar-brand md:me-8" href="index.html">
            <span style={{fontSize:"20px",fontWeight:"600"}} className="inline-block ">
                    UZMAN PSK. SALİH DEMİR
                </span>
                
            </Link>

            <div className="nav-icons flex items-center lg_992:order-2 ms-auto md:ms-8">
                {/* <!-- Navbar Button --> */}
                <ul className="list-none menu-social mb-0">
                    <li className="inline-flex">
                        {/*    <Link to="" className="ms-1">
                                <span className="login-btn-primary"><span className="btn btn-icon btn-sm rounded-full bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white"><Unicons.UilDribbble width={16}/></span></span>
                                <span className="login-btn-light"><span className="btn btn-icon btn-sm rounded-full bg-gray-50 hover:bg-gray-200 dark:bg-slate-900 dark:hover:bg-gray-700 hover:border-gray-100 dark:border-gray-700 dark:hover:border-gray-700"><Unicons.UilDribbble width={16}/></span></span>
                            </Link>*/}
                            <Link to="tel:05364916063" target="blank" className="ms-1">
                                <span className="login-btn-primary "><span className="btn btn-icon btn-sm rounded-full bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white"><Unicons.UilPhone width={16}/></span></span>
                                <span className="login-btn-light "><span className="btn btn-icon btn-sm rounded-full bg-gray-50 hover:bg-gray-200 dark:bg-slate-900 dark:hover:bg-gray-700 hover:border-gray-100 dark:border-gray-700 dark:hover:border-gray-700"><Unicons.UilPhone width={16}/></span></span>
                            </Link> 
                        <Link to="https://www.instagram.com/psikologsalihdemir/" target="_blank" className="ms-1">
                            <span className="login-btn-primary"><span className="btn btn-icon btn-sm rounded-full bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white"><Unicons.UilInstagram width={16}/></span></span>
                            <span className="login-btn-light"><span className="btn btn-icon btn-sm rounded-full bg-gray-50 hover:bg-gray-200 dark:bg-slate-900 dark:hover:bg-gray-700 hover:border-gray-100 dark:border-gray-700 dark:hover:border-gray-700"><Unicons.UilInstagram width={16}/></span></span>
                        </Link>
                    </li>
                </ul>
                {/* <!-- Navbar Collapse Manu Button --> */}
                <button onClick={hiddenFunc} data-collapse="menu-collapse" type="button" className="collapse-btn inline-flex items-center ms-2 text-dark " aria-controls="menu-collapse" aria-expanded="false">
                    <span className="sr-only">Navigation Menu</span>
                    {window.innerWidth<1024?<MdDehaze style={{width:"25px",height:"25px"}}/>:null}

                </button>
            </div>

            {/* <!-- Navbar Manu --> */}
            <div className="navigation lg_992:order-1 lg_992:flex hidden ms-auto" id="menu-collapse">
                <ul className="navbar-nav" id="navbar-navlist">
                   {/*  <li className="nav-item">
                        <Link1 to="home" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Ana sayfa</Link1>
                    </li> */}
                    <li className="nav-item">
                        <Link1 to="about" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Hakkımda</Link1>
                    </li>
                   {/*  <li className="nav-item">
                        <Link1 to="service" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Services</Link1>
                    </li> */}
                    <li className="nav-item">
                        <Link1 to="experience" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Deneyimler</Link1>
                    </li>
                    <li className="nav-item">
                        <Link1 to="project" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Testler</Link1>
                    </li>
                    <li className="nav-item">
                        <Link1 to="blog" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Blog</Link1>
                    </li>
                    <li className="nav-item">
                        <Link1 to="contact" activeClass="active" spy={true} smooth={true} duration={500} className="nav-link">Bizimle İletişime Geçin</Link1>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    )
}